import { TFunction } from 'i18next';

export function getSteps(type: 'consumer' | 'spot' | 'artist', t: TFunction) {
  const STEP_SPOT_CHECK_IN = t('signup.stepper.Your spot', { ns: 'authentication' });
  const STEP_ARTIST_CHECK_IN = t('signup.stepper.Your profile', { ns: 'authentication' });
  const STEP_CREATE_ACCOUNT = t('signup.stepper.Your account', { ns: 'authentication' });
  const STEP_PERSONAL_INFORMATION = t('signup.stepper.Your infos', { ns: 'authentication' });

  const CAPTION_SPOT_CHECK_IN = t('signup.stepper.Basic informations on your spot', { ns: 'authentication' });
  const CAPTION_ARTIST_CHECK_IN = t('signup.stepper.Your artist profile', { ns: 'authentication' });
  const CAPTION_CREATE_ACCOUNT = t('signup.stepper.Fill in the information that will allow you to connect', {
    ns: 'authentication',
  });
  const CAPTION_PERSONAL_INFORMATION = t('signup.stepper.Tell us a little more about yourself', {
    ns: 'authentication',
  });
  const CAPTION_SUMMARY = t('signup.stepper.Check the information you have entered', {
    ns: 'authentication',
  });

  switch (type) {
    case 'consumer':
      return {
        stepFieldValidations: [
          ['email', 'password', 'passwordConfirmation'],
          ['gender', 'firstname', 'lastname', 'birthdate'],
        ],
        steps: [STEP_CREATE_ACCOUNT, STEP_PERSONAL_INFORMATION],
        stepsCaptions: [CAPTION_CREATE_ACCOUNT, CAPTION_PERSONAL_INFORMATION, CAPTION_SUMMARY],
      };
    case 'spot':
      return {
        stepFieldValidations: [
          ['email', 'password', 'passwordConfirmation'],
          ['gender', 'firstname', 'lastname', 'birthdate'],
          ['siret', 'accountName', 'address'],
        ],
        steps: [STEP_CREATE_ACCOUNT, STEP_PERSONAL_INFORMATION, STEP_SPOT_CHECK_IN],
        stepsCaptions: [
          CAPTION_CREATE_ACCOUNT,
          CAPTION_PERSONAL_INFORMATION,
          CAPTION_SPOT_CHECK_IN,
          CAPTION_SUMMARY,
        ],
      };
    case 'artist':
      return {
        stepFieldValidations: [
          ['email', 'password', 'passwordConfirmation'],
          ['gender', 'firstname', 'lastname', 'birthdate'],
          ['accountName', 'art'],
        ],
        steps: [STEP_CREATE_ACCOUNT, STEP_PERSONAL_INFORMATION, STEP_ARTIST_CHECK_IN],
        stepsCaptions: [
          CAPTION_CREATE_ACCOUNT,
          CAPTION_PERSONAL_INFORMATION,
          CAPTION_ARTIST_CHECK_IN,
          CAPTION_SUMMARY,
        ],
      };
    default:
      throw new Error('Invalid type');
  }
}
